const CharacterSad = () => {
  return (
    <svg
      width='250'
      height='208'
      viewBox='0 0 250 208'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_77_1561)'>
        <path
          d='M184.742 121.474C181.37 119.953 177.297 118.701 173.438 118.061C170.494 117.573 168.751 120.682 170.273 123.249L173.265 128.295L174.862 131.15C168.528 135.379 172.959 148.733 183.632 147.003C192.167 145.62 194.685 134.877 192.076 129.181C191.17 126.602 189.868 123.784 184.742 121.474Z'
          fill='#DC4E00'
        />
      </g>
      <g filter='url(#filter1_d_77_1561)'>
        <path
          d='M88.0095 121.204C91.4094 119.748 95.5055 118.573 99.3767 118.006C102.329 117.574 104.013 120.716 102.443 123.253L99.3547 128.242L97.7045 131.066C103.957 135.414 99.2737 148.683 88.6354 146.75C80.1278 145.205 77.8144 134.416 80.5309 128.771C81.4859 126.21 82.8411 123.417 88.0095 121.204Z'
          fill='#DC4E00'
        />
      </g>
      <path
        d='M95.3682 98.0001C95.3682 75.0803 113.948 56.5001 136.868 56.5001C159.788 56.5001 178.368 75.0803 178.368 98.0001V157.5H95.3682V98.0001Z'
        fill='#FF5C02'
      />
      <path
        d='M95.3682 149.5H123.368V161.5C123.368 169.232 117.1 175.5 109.368 175.5C101.636 175.5 95.3682 169.232 95.3682 161.5V149.5Z'
        fill='#DC4E00'
      />
      <path
        d='M123.368 149.5H150.368V162C150.368 169.456 144.324 175.5 136.868 175.5C129.412 175.5 123.368 169.456 123.368 162V149.5Z'
        fill='#DC4E00'
      />
      <path
        d='M150.368 149.5H178.368V161.5C178.368 169.232 172.1 175.5 164.368 175.5C156.636 175.5 150.368 169.232 150.368 161.5V149.5Z'
        fill='#DC4E00'
      />
      <path
        d='M95.3682 148.5H123.368V150.5C123.368 158.232 117.1 164.5 109.368 164.5C101.636 164.5 95.3682 158.232 95.3682 150.5V148.5Z'
        fill='#FF5C02'
      />
      <path
        d='M123.368 148.5H150.368V151C150.368 158.456 144.324 164.5 136.868 164.5C129.412 164.5 123.368 158.456 123.368 151V148.5Z'
        fill='#FF5C02'
      />
      <path
        d='M150.368 148.5H178.368V150.5C178.368 158.232 172.1 164.5 164.368 164.5C156.636 164.5 150.368 158.232 150.368 150.5V148.5Z'
        fill='#FF5C02'
      />
      <path
        d='M132.141 119.418C133.398 116.836 136.87 116.788 138.448 117.086C138.831 117.137 139.409 117.374 140.015 117.672C141.473 118.39 142.352 119.841 143.301 121.161C143.915 122.014 144.532 122.391 144.875 122.437C147.119 122.736 147.688 120.609 147.535 119.619C144.94 114.204 140.844 113.45 139.441 113.263C138.038 113.076 131.042 112.663 128.174 117.039C125.88 120.54 127.902 121.938 129.2 122.199C129.656 122.347 130.883 122 132.141 119.418Z'
        fill='black'
      />
      <circle
        cx='153.451'
        cy='98.1755'
        r='8.5'
        fill='white'
        stroke='white'
        strokeWidth='4'
      />
      <circle cx='153.451' cy='102.176' r='6.5' fill='black' />
      <circle
        cx='122.451'
        cy='98.1755'
        r='8.5'
        fill='white'
        stroke='white'
        strokeWidth='4'
      />
      <circle cx='122.451' cy='102.176' r='6.5' fill='black' />
      <ellipse
        cx='137.295'
        cy='194.556'
        rx='47.2951'
        ry='8.05576'
        fill='#451B03'
        fillOpacity='0.12'
      />
      <path
        d='M142.764 75.3092C142.29 77.1224 140.417 78.2142 138.579 77.7465C136.742 77.2788 135.636 75.4301 136.11 73.616C136.583 71.8028 141.386 67 141.386 67C141.386 67 143.238 73.4959 142.764 75.31V75.3092Z'
        fill='#004664'
      />
      <path
        d='M171.252 79.9755C170.718 82.4375 168.264 84.0103 165.77 83.4866C163.276 82.9629 161.686 80.5418 162.219 78.0798C162.752 75.6178 168.929 68.8949 168.929 68.8949C168.929 68.8949 171.785 77.5135 171.252 79.9766L171.252 79.9755Z'
        fill='#004664'
      />
      <path
        d='M196.764 75.3092C196.29 77.1224 194.417 78.2142 192.579 77.7465C190.742 77.2788 189.636 75.4292 190.11 73.616C190.583 71.8028 195.386 67 195.386 67C195.386 67 197.237 73.4959 196.764 75.31V75.3092Z'
        fill='#004664'
      />
      <path
        d='M215.943 25.1489C211.535 21.9477 206.236 20.1623 200.897 19.7485C202.003 14.152 198.11 8.35058 191.323 6.10464C186.414 4.48377 181.2 5.12023 177.359 7.40665C176.469 5.86929 175.202 4.43822 173.541 3.23238C167.237 -1.34301 157.834 -1.02288 152.538 3.94981C151.127 5.27712 150.147 6.80183 149.594 8.41384C142.645 7.08906 135.21 8.76813 130.335 13.3448C125.376 18.0037 124.36 24.4505 127.014 30.0457C122.57 31.6185 118.926 34.6046 117.136 38.641C113.539 46.7491 118.768 56.0125 128.816 59.3352C133.641 60.9295 138.693 60.8498 143.046 59.4516C144.661 61.7406 147.192 63.6322 150.401 64.6938C156.212 66.6146 162.483 65.2202 166.133 61.6115C166.771 62.2809 167.488 62.9148 168.294 63.4981C175.122 68.4569 185.305 68.1064 191.04 62.7199C191.826 61.9848 192.488 61.1914 193.022 60.3588C202.252 62.73 212.495 60.7574 219.049 54.6017C228.068 46.1329 226.679 32.9458 215.942 25.1514L215.943 25.1489Z'
        fill='white'
      />
      <ellipse
        cx='54'
        cy='196.5'
        rx='15'
        ry='2.5'
        fill='#451B03'
        fillOpacity='0.12'
      />
      <g clipPath='url(#clip0_77_1561)'>
        <path
          d='M31.6342 144.429C32.2516 144.264 32.6166 143.636 32.452 143.022C32.1064 141.732 32.8819 140.398 34.179 140.05C35.476 139.702 36.8149 140.47 37.1605 141.76L44.7177 169.964C44.8822 170.578 45.5123 170.939 46.1297 170.774C46.7471 170.609 47.1121 169.98 46.9476 169.367L39.3904 141.163C38.7169 138.649 36.1123 137.155 33.5893 137.831C31.0662 138.507 29.5532 141.105 30.2266 143.618C30.3911 144.232 31.0212 144.594 31.6386 144.428L31.6342 144.429Z'
          fill='black'
        />
        <path
          d='M52.6949 195.437C53.45 195.235 53.8964 194.466 53.6952 193.715L52.4501 189.069C52.2489 188.318 51.4738 187.877 50.7231 188.078C49.9724 188.279 49.5215 189.048 49.7227 189.799L50.9679 194.446C51.1691 195.197 51.9442 195.638 52.6949 195.437Z'
          fill='black'
        />
        <path
          d='M51.915 192.526C39.8089 186.737 34.1003 177.141 31.5014 170.622C30.9387 169.215 29.0288 169.088 28.2202 170.37C26.3318 173.361 22.783 175.912 18.341 177.103C15.7513 177.796 13.1944 177.937 10.8921 177.607C9.16879 177.359 8.11509 179.45 9.32092 180.698C19.9179 191.711 36.0483 196.777 51.915 192.526Z'
          fill='#FD9415'
        />
        <path
          d='M51.9151 192.526C59.375 181.65 59.6442 170.68 58.6966 163.714C58.3962 161.527 55.5136 160.879 54.2944 162.725C52.3931 165.597 49.5737 168.739 45.8158 169.745C42.0579 170.752 38.0455 169.441 34.963 167.905C32.984 166.915 30.8083 168.923 31.645 170.962C34.3073 177.469 40.0258 186.835 51.924 192.524L51.9151 192.526Z'
          fill='#FFD702'
        />
        <path
          d='M51.9149 192.526C67.7816 188.275 79.2179 175.822 82.8942 160.989C83.3097 159.306 81.3562 158.021 79.9879 159.098C78.1591 160.535 75.8744 161.691 73.2847 162.385C68.8427 163.575 64.4938 163.14 61.3627 161.494C60.017 160.789 58.4266 161.855 58.6472 163.353C59.6547 170.293 59.5101 181.463 51.9205 192.529L51.9149 192.526Z'
          fill='#FD9415'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_77_1561'
          x='165.711'
          y='118.01'
          width='31.3467'
          height='37.1472'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_77_1561'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_77_1561'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_77_1561'
          x='75.4526'
          y='117.966'
          width='31.5898'
          height='36.9749'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_77_1561'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_77_1561'
            result='shape'
          />
        </filter>
        <clipPath id='clip0_77_1561'>
          <rect
            width='76.6413'
            height='60.5831'
            fill='white'
            transform='translate(89.71 185.519) rotate(165)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CharacterSad;
